import React, { Component } from 'react';

import { FormStore } from 'core/forms/FormStore';

import { TwoColumnLayoutHOC } from 'containers/layouts/TwoColumnLayout/TwoColumnLayoutHOC';
import { myAccountHOC } from 'containers/MyAccount/MyAccount';

import { ChangePasswordForm } from './ChangePasswordForm';
import ChangePasswordDescription from './ChangePasswordDescription';

import ChangePasswordFormValidation from './formValidation';
import formValues from './formValues';

import { localeStrings as strings } from 'applicationConfig';

class ChangePassword extends Component {
  render() {
    const formStore = new FormStore(
      formValues,
      new ChangePasswordFormValidation(strings.changePassword.passwordsDoNotMatchMessage)
    );

    return (
      <div {...this.props}>
        <p>{strings.changePassword.caption}</p>
        <ChangePasswordForm formStore={formStore} />
      </div>
    );
  }
}

export default myAccountHOC(TwoColumnLayoutHOC(ChangePassword, ChangePasswordDescription));



// WEBPACK FOOTER //
// ./src/containers/MyAccount/ChangePassword/ChangePassword.jsx